module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.paginator.current_page < _vm.paginator.total_pages) ? _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.$emit('loadMoreItems', _vm.paginator.current_page + 1)
      }
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _c('span', [_vm._v("more")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e014ce2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Paginator.vue
// module id = 394
// module chunks = 1